module.exports = __webpack_public_path__ + "static/easyeducation-env1-min-53863e0cf4af70be9e7cd2990f6e3f3e.jpg";